// ============================================================================
// AppRoutingModule - Route Table with Lazy-Loaded Feature Modules
// ============================================================================
// Replaces V1's $routeProvider in app.js. All feature modules lazy-load under
// the ShellComponent layout with AuthGuard. Login and extquote routes bypass
// the shell. Includes SPA-friendly redirects for legacy /sku/ and /product/ URLs.
// ============================================================================

import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ShellComponent } from './layout/shell.component';
import { AuthGuard } from './core/auth.guard';

const routes: Routes = [
  // Auth routes (no shell, no guard)
  { path: 'login', loadChildren: () => import('./auth/auth.module').then(m => m.AuthModule) },
  // External quote sharing (anonymous, no shell)
  { path: 'extquote', redirectTo: 'login/extquote', pathMatch: 'prefix' },

  // App routes (wrapped in shell layout, guarded)
  {
    path: '',
    component: ShellComponent,
    canActivate: [AuthGuard],
    children: [
      { path: 'dash', loadChildren: () => import('./dashboard/dashboard.module').then(m => m.DashboardModule) },
      { path: 'quotes', loadChildren: () => import('./quotes/quotes.module').then(m => m.QuotesModule) },
      { path: 'orders', loadChildren: () => import('./orders/orders.module').then(m => m.OrdersModule) },
      { path: 'products', loadChildren: () => import('./products/products.module').then(m => m.ProductsModule) },
      { path: 'favorites', loadChildren: () => import('./favorites/favorites.module').then(m => m.FavoritesModule) },
      { path: 'rmas', loadChildren: () => import('./rmas/rmas.module').then(m => m.RmasModule) },
      { path: 'search', loadChildren: () => import('./search/search.module').then(m => m.SearchModule) },
      { path: 'settings', loadChildren: () => import('./settings/settings.module').then(m => m.SettingsModule) },
      { path: 'balance', loadChildren: () => import('./balance/balance.module').then(m => m.BalanceModule) },
      { path: 'files', loadChildren: () => import('./files/files.module').then(m => m.FilesModule) },
      { path: 'configurator', loadChildren: () => import('./configurator/configurator.module').then(m => m.ConfiguratorModule) },
      { path: 'product/:sku', redirectTo: 'products/detail/:sku' },
      { path: 'sku/:sku', redirectTo: 'products/detail/:sku' },
      { path: 'thankyou', redirectTo: 'dash/thankyou', pathMatch: 'full' },
      { path: '', redirectTo: 'dash', pathMatch: 'full' }
    ]
  },

  { path: '**', redirectTo: 'dash' }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule {}
